import React from 'react';
import { NewsItem } from '../services/mcpClient';

interface FinancialNewsProps {
  news: NewsItem[];
  loading: boolean;
  error: string | null;
}

const FinancialNews: React.FC<FinancialNewsProps> = ({ news, loading, error }) => {
  if (loading) {
    return (
      <div className="financial-news">
        <h3>📰 Financial News</h3>
        <div className="loading">Loading financial news...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="financial-news">
        <h3>📰 Financial News</h3>
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="financial-news">
      <h3>📰 Financial News</h3>
      <div className="news-list">
        {news.length === 0 ? (
          <div className="no-news">No news available</div>
        ) : (
          news.map((article) => (
            <div key={article.uuid} className="news-item">
              <div className="news-header">
                <h4 className="news-title">
                  <a 
                    href={article.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="news-link"
                  >
                    {article.title}
                  </a>
                </h4>
                <div className="news-meta">
                  <span className="news-publisher">{article.publisher}</span>
                  <span className="news-time">
                    {new Date(article.providerPublishTime).toLocaleString()}
                  </span>
                </div>
              </div>
              {article.thumbnail && (
                <div className="news-thumbnail">
                  <img 
                    src={article.thumbnail} 
                    alt={article.title}
                    className="thumbnail-image"
                  />
                </div>
              )}
              {article.relatedTickers && article.relatedTickers.length > 0 && (
                <div className="news-tickers">
                  <span className="tickers-label">Related:</span>
                  {article.relatedTickers.map((ticker, index) => (
                    <span key={index} className="ticker-tag">
                      {ticker}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default FinancialNews;

